import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

/**
 * Soleina – ajout au panier depuis les recommandations du panier.
 * Reprend le mécanisme natif du thème (CartLinesUpdateEvent + sections) pour que
 * le tiroir, la page panier et le compteur se mettent à jour sans rechargement.
 */
if (!window.__soleinaUpsellInit) {
  window.__soleinaUpsellInit = true;

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target ? target.closest('[data-soleina-upsell-add]') : null;
    if (!(button instanceof HTMLButtonElement)) return;

    event.preventDefault();
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = button.getAttribute('data-adding-text') || originalText;

    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    const deferred = CartLinesUpdateEvent.createPromise();
    button.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    const restore = () => {
      button.textContent = originalText;
      button.disabled = false;
    };

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      }).then((r) => r.json());

      const cart = await fetch(`${Theme.routes.cart_url}.json`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((r) => r.json());

      if (response.status) {
        button.dispatchEvent(new CartErrorEvent({ error: response.message || 'Add to cart failed', code: 'INVALID' }));
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { didError: true, items: cart.items, source: 'soleina-upsell', itemCount: 1 },
        });
        restore();
        return;
      }

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'soleina-upsell',
          itemCount: 1,
          sections: response.sections,
          didError: false,
        },
      });

      button.textContent = button.getAttribute('data-added-text') || originalText;
      setTimeout(restore, 1500);
    } catch (error) {
      console.error(error);
      deferred.reject(error);
      button.dispatchEvent(
        new CartErrorEvent({ error: (error && error.message) || 'Network error', code: 'SERVICE_UNAVAILABLE' })
      );
      restore();
    }
  });
}
